import { CalculationMode, CalculationStatus } from '@ydistri/api-sdk';
import React from 'react';
import { useTheme } from 'styled-components';
import CalculationStatusComponent from './CalculationStatusComponent';

interface CalculationStatusContainerProps {
  status: CalculationStatus;
  mode: CalculationMode;
}

const CalculationStatusController: React.FC<CalculationStatusContainerProps> = ({
  status,
  mode,
}) => {
  const theme = useTheme();
  switch (status) {
    case CalculationStatus.Pending: {
      if (mode === CalculationMode.Manual) {
        return <CalculationStatusComponent label="Please import data" showSpinner={false} />;
      } else {
        return <CalculationStatusComponent label="Calculation pending" />;
      }
    }
    case CalculationStatus.Queued: {
      return <CalculationStatusComponent label="Calculation queued" />;
    }
    case CalculationStatus.Running: {
      return <CalculationStatusComponent label="Calculation running" />;
    }
    case CalculationStatus.Crashed: {
      return <CalculationStatusComponent label="Calculation failed" showSpinner={false} />;
    }
    case CalculationStatus.SoftDeleted: {
      return (
        <CalculationStatusComponent
          label="Calculation to be deleted"
          spinnerColor={theme.colors.danger}
        />
      );
    }
    case CalculationStatus.Completed:
    case CalculationStatus.ToBeQueued:
    case CalculationStatus.Outdated:
    case CalculationStatus.Editing:
      return null;
  }
};

export default CalculationStatusController;
